
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invites",
      function () {
        return require("private-next-pages/invites.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invites"])
      });
    }
  